export default __webpack_public_path__ + "static/2142-454b5289883dd72f457cdda6a8c485f4.pdf";